<template>
    <div>
        <div class="content-wrapper">
            <section class="content-header">
                <h1>
                    Statistiques générales
                    <small></small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li><a href="#">Statistiques</a></li>
                    <li class="active"><a href="#">Statistiques générales</a></li>
                </ol>
            </section>

            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-tabs-custom nav-tabs-custom-bottom">
                            <ul class="nav nav-tabs" role="tablist">
                                <li :class="active==1 ? 'active' : '' ">
                                    <a href="#member_tab_1"
                                       aria-controls="#member_tab_1"
                                       data-toggle="tab"
                                       @click="active=1"

                                       aria-expanded="false">Statistiques générales ABFT</a>
                                </li>
                                <li :class="active==2 ? 'active' : '' ">
                                    <a href="#member_tab_2"
                                       aria-controls="#member_tab_2"
                                       data-toggle="tab"
                                       @click="active=2"
                                       aria-expanded="false">Statistiques et fichiers pour les comités</a>
                                </li>

                                <li :class="active==3 ? 'active' : '' ">
                                    <a href="#member_tab_3"
                                       aria-controls="#member_tab_3"
                                       data-toggle="tab"
                                       @click="active=3"
                                       aria-expanded="false">Statistiques et fichiers pour le secrétariat</a>
                                </li>
                                <li :class="active==4 ? 'active' : '' ">
                                    <a href="#member_tab_4"
                                       aria-controls="#member_tab_4"
                                       data-toggle="tab"
                                       @click="active=4"
                                       aria-expanded="false">Statistiques et fichiers pour le directeur sportif</a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row tab-content">
                    <div role="tabpanel" :class="active==1 ? 'active' : '' " class="col-md-12 tab-pane " id="member_tab_1">
                        <GeneralAbft></GeneralAbft>
                    </div>

                    <div role="tabpanel" :class="active==2 ? 'active' : '' " class="col-md-12 tab-pane" id="member_tab_2">
                        <GeneralComites></GeneralComites>
                    </div>

                    <div role="tabpanel" :class="active==3 ? 'active' : '' " class="col-md-12 tab-pane" id="member_tab_3">
                        <GeneralSecretariat></GeneralSecretariat>
                    </div>
                    <div role="tabpanel" :class="active==4 ? 'active' : '' " class="col-md-12 tab-pane" id="member_tab_3">
                        <GeneralSportif></GeneralSportif>
                    </div>

                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import GeneralAbft from './General_abft'
    import GeneralComites from './General_comites'
    import GeneralSportif from './General_sportif'
    import GeneralSecretariat from './General_secretariat'

    export default {
        data() {
            return {
                loading: false,
                active: 1
            }
        },
        props: {},
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
            })
        },
        methods: {
            ...mapActions({
                setRecap: 'setRecap',
            }),
            loadingComplete: function () {
                return this.recap_id == 0 ? true :
                    (this.getRecap != null && this.getStatusRecap != null)
            },
        },

        watch: {},
        components: {
            GeneralAbft: GeneralAbft,
            GeneralComites: GeneralComites,
            GeneralSecretariat: GeneralSecretariat,
            GeneralSportif: GeneralSportif,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Statistiques/General/AppStatsGeneral.vue